<div class="Home_wrapper">
  <div *ngFor="let service of services" class="Home_wrapper_service">
    <app-dcl [component]="service.component"></app-dcl>
  </div>
</div>
